import { render, staticRenderFns } from "./answerExercisesItem.vue?vue&type=template&id=67766ced&scoped=true&"
import script from "./answerExercisesItem.vue?vue&type=script&lang=js&"
export * from "./answerExercisesItem.vue?vue&type=script&lang=js&"
import style0 from "./answerExercisesItem.vue?vue&type=style&index=0&id=67766ced&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67766ced",
  null
  
)

export default component.exports